import { Directive, HostListener } from '@angular/core';

@Directive({ selector: '[appDateMask]' })
export class DateMaskDirective {
  @HostListener('input', ['$event'])
  public onKeyDown(event: InputEvent): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(new RegExp(/[A-Za-z]/g, 'gi'), '');
    if (event.data && +value[0] > 1) {
      if (value.match(/^\d{1}$/) !== null) {
        input.value = value + '/';
      } else if (value.match(/^\d{1}\/\d{2}$/) !== null) {
        input.value = value + '/';
      } else {
        input.value = value;
      }
    } else if (event.data) {
      if (value.match(/^\d{2}$/) !== null) {
        input.value = value + '/';
      } else if (value.match(/^\d{2}\/\d{2}$/) !== null) {
        input.value = value + '/';
      } else {
        input.value = value;
      }
    }
  }
}
